import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  { path: '/login', component: () => import('../views/Login.vue'), meta: { title: '登录' } },
  {
    path: '/',
    component: () => import('../layout/index.vue'),
    redirect: '/dashboard',
    children: [
      { path: 'dashboard', component: () => import('../views/Dashboard.vue'), meta: { title: '仪表盘' } },
      { path: 'games', component: () => import('../views/GameList.vue'), meta: { title: '游戏列表' } },
      { path: 'games/:id', component: () => import('../views/GameDetail.vue'), meta: { title: '游戏详情' } },
      { path: 'games/:id/edit', component: () => import('../views/GameEdit.vue'), meta: { title: '编辑游戏' } },
      { path: 'mobile-games', component: () => import('../views/MobileGameList.vue'), meta: { title: '手机游戏列表' } },
      { path: 'mobile-games/:id', component: () => import('../views/MobileGameDetail.vue'), meta: { title: '手机游戏详情' } },
      { path: 'mobile-games/:id/edit', component: () => import('../views/MobileGameEdit.vue'), meta: { title: '编辑手机游戏' } },
      { path: 'tools', component: () => import('../views/Tools.vue'), meta: { title: '游戏工具列表' } },
      { path: 'faq', component: () => import('../views/Faq.vue'), meta: { title: '常见问题' } },
      { path: 'feedback', component: () => import('../views/Feedback.vue'), meta: { title: '反馈处理' } },
      { path: 'pan', component: () => import('../views/PanManage.vue'), meta: { title: '网盘管理' } },
      { path: 'pan-search', component: () => import('../views/PanSearch.vue'), meta: { title: '网盘游戏搜索' } },
      { path: 'crawler', component: () => import('../views/CrawlerManage.vue'), meta: { title: '爬虫管理' } },
    ],
  },
];

const router = new VueRouter({ routes });

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('hs_admin_token');
  if (to.path !== '/login' && !token) return next('/login');
  if (to.path === '/login' && token) return next('/dashboard');
  document.title = to.meta?.title ? `${to.meta.title} · hsGame 管理后台` : 'hsGame 管理后台';
  next();
});

export default router;
